module.exports = __webpack_public_path__ + "img/teflon_and_teflon_covered_nipple_into_flange.ca68f0b7.webp";